import { NavSection } from "@ecologi/react-components/src/NavigationDrawer/navigation";
import { User } from "@ecologi/shared";
import { addIdsToNavSection } from "./add-ids-to-nav-section";

export const getNavSectionsForMarketingSite = ({
  productsInBasket,
  user,
}: {
  productsInBasket?: number;
  user?: User;
}): NavSection[] =>
  [
    [
      {
        label: "Home",
        path: "/",
      },
      {
        label: "Solutions",
        links: [
          {
            label: "For large businesses over 50 employees",
            path: "/solutions/for-large-businesses",
          },
          {
            label: "For small businesses under 50 employees",
            path: "/solutions/for-small-businesses",
          },
        ],
      },
      {
        label: "Climate action",
        links: [
          {
            label: "Carbon removals",
            path: "/climate-action/carbon-removals",
          },
          {
            label: "Carbon avoidance",
            path: "/climate-action/carbon-avoidance",
          },
          {
            label: "Reforestation",
            path: "/climate-action/reforestation",
          },
          {
            label: "Habitat restoration",
            path: "/climate-action/habitat-restoration",
          },
          {
            label: "Impact funds",
            path: "/climate-action/impact-funds",
          },
        ],
      },
      {
        label: "Why Ecologi",
        links: [
          {
            label: "About",
            path: "/why-ecologi/about",
          },
          {
            label: "Transparency",
            path: "/why-ecologi/trust-through-transparency",
          },
        ],
      },
      {
        label: "Our impact",
        links: [
          {
            label: "Climate projects",
            path: "/projects",
          },
        ],
      },
      {
        label: "Resources",
        links: [
          {
            label: "Blog",
            path: "/articles",
          },
          {
            label: "Help centre",
            path: "https://help.ecologi.com/",
          },
          {
            label: "Webinars",
            path: "/resources/webinars",
          },
        ],
      },
    ],
    user
      ? [
          {
            label: "Your profile 🌿",
            path: user.getProfilePath(),
            route: user.isChildProfile
              ? "/[usernameOrId]/[childUsernameOrId]"
              : "/[usernameOrId]",
          },
          {
            label: " Logout",
            path: "/api/logout",
          },
        ]
      : [
          {
            label: "Sign in 🌿",
            path: "/api/login",
          },
          {
            label: "Get started",
            path: "/solutions",
          },
        ],
    [
      {
        label: "Speak to the team",
        path: "/page/schedule-a-call",
      },
    ],
  ].map(addIdsToNavSection);
